export { default } from './auth-form-error';
